import {ChartConfig} from '@models/machine/chart-config';
import {TrafficLightConfiguration} from '@models/machine/traffic-light/traffic-light-configuration';
import {LocationDetails} from '@models/locationDetails/location-details';

export class Machine {
  id?: number;
  location: string;
  locationDetails: LocationDetails;
  name: string;
  parentId: number;
  type: string;
  category: string;
  chartConfig: ChartConfig;
  dataSourcePartitioning: boolean;
  tenant?: number;
  trafficLightConfiguration: TrafficLightConfiguration;
  projectId: string;
  datasetLocation: string;
  tableauProjectId: string;
  machineTag: string;
  streamToPubSub?: boolean;
  triggerExecutionInDataflow?: boolean;
  liveStreamingInDataflow?: boolean;
  dataWarehouseStreamingInDataflow?: boolean;
  group?: string;
  signals: any;
  tableauViews: any;
  adminSharedPages: any;
  externalId: string;
  parentExternalId: string;
  createdBy: string;
  creationTime: Date | undefined;
  templateMachine: boolean = false;
  normalizedName: string = '';
  machineCategoryId: number | undefined;

  constructor(machine?) {
    this.id = machine?.id;
    this.location = machine?.location || '';
    this.locationDetails = machine?.locationDetails || new LocationDetails();
    this.name = machine?.name || '';
    this.parentId = machine?.parentId || -1;
    this.type = machine?.type || '';
    this.category = machine?.category || '';
    this.chartConfig = machine?.chartConfig || new ChartConfig;
    this.dataSourcePartitioning = machine?.dataSourcePartitioning || false;
    this.tenant = machine?.tenant;
    this.trafficLightConfiguration = machine?.trafficLightConfiguration || new TrafficLightConfiguration();
    this.projectId = machine?.projectId || '';
    this.datasetLocation = machine?.datasetLocation || '';
    this.tableauProjectId = machine?.tableauProjectId || '';
    this.machineTag = machine?.machineTag || '';
    this.streamToPubSub = machine?.streamToPubSub || false;
    this.triggerExecutionInDataflow = machine?.triggerExecutionInDataflow || false;
    this.liveStreamingInDataflow = machine?.liveStreamingInDataflow || false;
    this.dataWarehouseStreamingInDataflow = machine?.dataWarehouseStreamingInDataflow || false;
    this.group = machine?.group || '';
    this.signals = machine?.signals;
    this.tableauViews = machine?.tableauViews;
    this.adminSharedPages = machine?.adminSharedPages;
    this.externalId = machine?.externalId || '';
    this.parentExternalId = machine?.parentExternalId || '';
    this.createdBy = machine?.createdBy || '';
    this.creationTime = machine?.creationTime;
    this.templateMachine = machine?.templateMachine || false;
    this.normalizedName = machine?.normalizedName || '';
    this.machineCategoryId = machine?.machineCategoryId || -1;
  }

  public isLocationAvailable(): boolean {
    return !!this.locationDetails.longitude && !!this.locationDetails.latitude;
  }
}
